import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {appRouting} from './app.routing';
import {MailService} from './shared/mail.service';
import {AppComponent} from './app.component';
import {NavigationComponent} from './navigation/navigation.component';
import {ContactComponent} from './contact/contact.component';
import {HomeComponent} from './home/home.component';
import {ImprintComponent} from './imprint/imprint.component';
import {RequirementsComponent} from './requirements/requirements.component';
import {DisclaimerComponent} from './disclaimer/disclaimer.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {FlashMessagesModule} from 'angular2-flash-messages';
import {ScrollToModule} from 'ng2-scroll-to';

@NgModule({
    declarations: [
        AppComponent,
        NavigationComponent,
        NotFoundComponent,
        HomeComponent,
        ImprintComponent,
        DisclaimerComponent,
        ContactComponent,
        RequirementsComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        appRouting,
        FlashMessagesModule,
        ScrollToModule.forRoot(),
    ],
    providers: [MailService],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/app.module.ts